import React from "react";

const AnalyticsContent = () => {
    return (
        <div>
            <h2 className="text-2xl font-bold mb-4">Analytics</h2>
            <p>View detailed analytics here.</p>
        </div>
    );
};

export default AnalyticsContent;
